var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.717,
    height: 20.005,
    viewBox: "0 0 15.717 20.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    transform: "translate(-47.037 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(47.037 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M60.754,2.621h-1.81v-.81c0-.262-.286-.381-.548-.381H56.991A2.13,2.13,0,0,0,54.872,0a2.167,2.167,0,0,0-2.119,1.429H51.371c-.262,0-.524.119-.524.381v.81h-1.81a2.024,2.024,0,0,0-2,1.929V18.2a1.916,1.916,0,0,0,2,1.81H60.754a1.916,1.916,0,0,0,2-1.81V4.55A2.024,2.024,0,0,0,60.754,2.621ZM51.8,2.383h1.31a.524.524,0,0,0,.452-.429A1.381,1.381,0,0,1,54.872.883a1.357,1.357,0,0,1,1.286,1.072.524.524,0,0,0,.476.429h1.357V4.288H51.8ZM61.8,18.2a.966.966,0,0,1-1.048.857H49.037A.966.966,0,0,1,47.99,18.2V4.55a1.072,1.072,0,0,1,1.048-.976h1.81V4.788a.5.5,0,0,0,.524.452H58.4a.524.524,0,0,0,.548-.452V3.574h1.81A1.072,1.072,0,0,1,61.8,4.55V18.2Z",
    transform: "translate(-47.037 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M103.02,230.46a.476.476,0,0,0-.667-.024l-1.524,1.453-.643-.667a.476.476,0,0,0-.667-.024.5.5,0,0,0,0,.691l.976,1a.429.429,0,0,0,.333.143.476.476,0,0,0,.333-.143l1.858-1.762a.452.452,0,0,0,.027-.639Z",
    transform: "translate(-96.995 -219.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M204.5,256.034h-5.477a.476.476,0,0,0,0,.953H204.5a.476.476,0,0,0,0-.953Z",
    transform: "translate(-191.642 -244.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M103.02,146.868a.476.476,0,0,0-.667-.024l-1.524,1.453-.643-.667a.476.476,0,0,0-.667-.024.5.5,0,0,0,0,.691l.976,1a.429.429,0,0,0,.333.143.476.476,0,0,0,.333-.143l1.858-1.762a.452.452,0,0,0,.027-.639Z",
    transform: "translate(-96.995 -140.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M204.5,172.442h-5.477a.476.476,0,0,0,0,.953H204.5a.476.476,0,0,0,0-.953Z",
    transform: "translate(-191.642 -164.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M103.02,314.051a.476.476,0,0,0-.667-.024l-1.524,1.453-.643-.667a.476.476,0,0,0-.667-.024.5.5,0,0,0,0,.691l.976,1a.428.428,0,0,0,.333.143.476.476,0,0,0,.333-.143l1.858-1.762a.452.452,0,0,0,.027-.639Z",
    transform: "translate(-96.995 -299.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M204.5,339.626h-5.477a.476.476,0,0,0,0,.953H204.5a.476.476,0,0,0,0-.953Z",
    transform: "translate(-191.642 -324.145)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/Order.d74a7f0c3f91f89041228c98341e0b5c.svg";
export { ForwardRef as ReactComponent };